import { render, staticRenderFns } from "./lists-detail.view.vue?vue&type=template&id=fce91a60&scoped=true&"
import script from "./lists-detail.view.vue?vue&type=script&lang=ts&"
export * from "./lists-detail.view.vue?vue&type=script&lang=ts&"
import style0 from "./lists-detail.view.vue?vue&type=style&index=0&id=fce91a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce91a60",
  null
  
)

export default component.exports